import { environment as env } from "../../../environments/environment";
import MetaMaskOnboarding from '@metamask/onboarding';
import Web3 from "web3";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable, throwError } from 'rxjs';


@Injectable({ providedIn: "root" })
export class MetamaskService {

    // async post(): Observable<any> {

    //     const { ethereum } = window;
    //     return ethereum && ethereum.isMetaMask;  
    //   }

    public IsMetaMaskInstalled() {

        if (window["ethereum"]) {
            return window["ethereum"].isMetaMask;
        }
        return false;

    }

    public StartOnboard() {
        let forwarderOrigin = window.location.href;
    
        const onboarding = new MetaMaskOnboarding({ forwarderOrigin });
        onboarding.startOnboarding();
      }


}